import ThisModule from "./PageCookiePolicy";

export default ThisModule;
